export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7951.b47177a9.jpg";